module.exports = __webpack_public_path__ + "static/media/progress.5f0bb641.svg";